module.exports = __webpack_public_path__ + "static/media/soccer-ball-variant.166dacd3.png";